import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

try {
  const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
  if (!reduce) document.documentElement.style.scrollBehavior = 'smooth';
} catch {
  // no-op
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
